import { addEventListener, removeEventListener } from 'grey-event';
var SharedObject = /** @class */ (function () {
    /**
     * 构造函数
     * @param top Local 的载体
     */
    function SharedObject(win) {
        var _this = this;
        if (win === void 0) { win = window; }
        /** 已经注册的监听 */
        this.keyMap = new Map();
        /** 注册监听 */
        this.on = function (key, method) {
            // 获取 key 对应的监听列表
            var item = _this.keyMap.get(key);
            if (item) {
                // 判断监听列表里有不有相同的代理
                var isHas = item.some(function (value) {
                    return value.method === method;
                });
                // 没有相同的代理，就添加
                if (isHas === false) {
                    item.push({ key: key, method: method });
                }
            }
            else {
                _this.keyMap.set(key, [{ key: key, method: method }]);
                if (_this.keyMap.size === 1) {
                    _this.startMethod();
                }
            }
        };
        /** 注销监听 */
        this.off = function (key, method) {
            // 获取一个已经去掉里指定代理的列表
            var item = _this.keyMap.get(key);
            if (item) {
                var list = item.filter(function (value) {
                    if (value.method === method) {
                        return false;
                    }
                    else {
                        return true;
                    }
                });
                // 如果列表为空就删除这个key的监听
                if (list.length > 0) {
                    _this.keyMap.set(key, list);
                }
                else {
                    _this.keyMap.delete(key);
                    _this.closeMethod();
                }
            }
        };
        /** 获取对象 */
        this.get = function (key) {
            return _this.win.localStorage.getItem(key);
        };
        /** 设置对象 */
        this.set = function (key, value) {
            _this.win.localStorage.setItem(key, value);
            window.dispatchEvent(new StorageEvent('storage', { key: key, oldValue: _this.get(key), newValue: value }));
        };
        /** 开始监听 */
        this.startMethod = function () {
            addEventListener(_this.win, 'storage', _this.onStorageHandler);
        };
        /** 关闭监听 */
        this.closeMethod = function () {
            removeEventListener(_this.win, 'storage', _this.onStorageHandler);
        };
        /** 对象发生改变 */
        this.onStorageHandler = function (e) {
            // 获取一个已经去掉里指定代理的列表
            if (!e.key) {
                return;
            }
            var key = e.key;
            var item = _this.keyMap.get(e.key);
            if (!item) {
                return;
            }
            item.forEach(function (value) {
                value.method({ oldDate: e.oldValue, newDate: e.newValue, key: key, win: _this.win });
            });
        };
        this.win = win;
    }
    return SharedObject;
}());
export { SharedObject };



// WEBPACK FOOTER //
// ./src/node_modules/grey-shared-object/index.js